module.exports = __webpack_public_path__ + "img/bag_filled.15a313f7.svg";